import { Component, HostBinding } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import { UserTranslationService } from '../../../services/user-translation/user-translation.service';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
})
export class LoginComponent {
  @HostBinding('class') cAppClass = 'c-app flex-row align-items-center';

  public isLoading = false;
  public errMsg = '';
  public mobile = null;
  public password = null;
  public isOwner = 'Y';

  // user: 923098272147
  // pass: Arena@123

  constructor(
    private router: Router,
    private storageSrv: StorageService,
    private localInterfaceSrv: LocalInterfaceService,
    private activatedRoute: ActivatedRoute,
    public userTranslationService: UserTranslationService,
  ) {

  }

  async ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      var token = params.get('token');
      token != null ? this.login(token) : '';
    });

    if (await this.storageSrv.isLoggedin()) {
      if (this.storageSrv.getIsStaff() == '1') {
        this.goToDashboard();
      }
      else {
        this.goToCalendar();
      }
    }
  }

  goToDashboard = () => {
    this.router.navigate(['/dashboard']);
  }
  goToCalendar = () => {
    this.router.navigate(['/calendar']);
  }

  goToFacilityList = () => {
    this.router.navigate(['/facilityList']);
  }

  goToForceChangePassword = () => {
    this.router.navigate(['/change-password/']);
  }
  signOut = () => {
    this.storageSrv.signOut();
  }

  login = async (token) => {
    if (await token == null ? this.validateInput() : true) {
      this.isLoading = true;
      this.localInterfaceSrv.login(this.mobile, this.password, token)
        .then(res => {
          if (res.content[0].forceChangePassword == 1) {
            this.goToForceChangePassword();
          }
          else {
            if (res.content[0].isStaff == 1) {
              this.goToCalendar();
            }
            else if (res.content[0].type == 'coach') {
              this.goToCalendar();
            }
            else if (res.content[0].type == 'admin') {
              this.goToFacilityList();
            }
            else if (res.content[0].type == 'owner') {
              this.goToDashboard();
            }
            else if (res.content[0].type == 'user') {
              this.signOut();
            }
          }
        })
        .catch(err => { this.errMsg = err.desc; })
        .finally(() => { this.isLoading = false; });
    }
  }

  validateInput() {
    return new Promise<any>((resolve) => {
      this.errMsg = '';
      if (!this.mobile || this.mobile.trim() === '') {
        this.errMsg = 'Please enter a valid mobile';
        resolve(false);
      }
      else if (!this.password || this.password.trim() === '') {
        this.errMsg = 'Please enter a password';
        resolve(false);
      }
      else {
        resolve(true);
      }
    });
  }
}
